// removed by extract-text-webpack-plugin
module.exports = {"intro-text":"_2Mai3","introText":"_2Mai3","title":"_2zcqb","text":"_3ZVj8","footer":"VoAFZ","link-more":"_2bog2","linkMore":"_2bog2"};